import {useState, useEffect, useContext, StrictMode} from "react"
import { useForm, useWatch } from "react-hook-form";
import { useEstadoApp } from "../context/EstadoAppContext";
import { useFormContext } from "../context/FormContext";
import { useRedContext } from '../context/RedContext';

import { Tabs } from "./Tabs";
import FormA from "./formA";
import FormB_Tramitacion from './formB_Tramitacion';
import FormC_SeguimientoObra from "./formC_SeguimientoObra";
//NUEVOS TABS
//import TabA_Datos_Entidades from "./TabA_Datos_Entidad";
//import TabB_Autoridades from "./TabB_Autoridades";
//import TabC_Situacion_Legal from "./TabC_Situacion_Legal";
//import TabD_Infra from "./TabD_Infra";
//import TabE_Vida_Deportiva from "./TabE_Vida_Deportiva";
//import TabF_Diagnostico from "./TabF_Diagnostico";

import TabI_Identidad from "./TabI_Identidad";
import TabII_Legal_Social from "./TabII_Legal_Social";
import TabIII_Predio from "./TabIII_Predio";
import TabIV_Infra from "./TabIV_Infra";
import TabV_Vida_Deportiva from "./TabV_Vida_Deportiva";
import TabVI_Diagnostico from "./TabVI_Diagnostico";


import { Input, Label, Button} from "../components/ui"
import { FormProvider } from '../context/FormContext';

const NuevaEditRED = () => { 
    
    const { formData, updateSection } = useRedContext();

    //acceder a area_responsable desde el useFormContext ---> formA. Datos Generales
    const {formA} = useFormContext();
    const {datosGenerales} = formA;
    const {area_responsable} = datosGenerales;
    console.log("TEST area_responsable ---->", area_responsable)

    //acceder a estadoAppX desde useEstadoApp
    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();

    // Definición de las pestañas
    const items = [
        /*
        {
            id: "tab1",
            label: 'CARACTERÍSTICAS GENERALES',
            form: <FormA 
                estadoAppX={estadoAppX} //podria acceder en formA desde el contexto, pero como ya lo tenemos lo pasamos
            />
        },
        {
            id: "tab2",
            label: 'TRAMITACIÓN',
            form: <FormB_Tramitacion />
        },
        {
            id: "tab3",
            label: 'SEGUIMIENTO DE OBRA',
            form: <FormC_SeguimientoObra />
        },
        */
        /*{
            id: "tab4",
            label: 'DATOS DE LA ENTIDAD',
            form: <TabA_Datos_Entidades 
                data={formData.identidad}
                onChange={(newData) => updateSection('identidad', newData)}
            />
        },       
        {
            id: "tab5",
            label: 'AUTORIDADES',
            form: <TabB_Autoridades 
                data={formData.legalSocial}
                onChange={(newData) => updateSection('legalSocial', newData)}
            />
        },
        {
            id: "tab6",
            label: 'SITUACIÓN LEGAL',
            form: <TabC_Situacion_Legal 
                data={formData.predio}
                onChange={(newData) => updateSection('predio', newData)}
            />
        },
        {
            id: "tab7",
            label: 'INFRAESTRUCTURA',
            form: <TabD_Infra 
                data={formData.infra} // <-- Si formData.infra es undefined, saltará el error
                onChange={(newData) => updateSection('infra', newData)}
            />
        },
        {
            id: "tab5",
            label: 'VIDA DEPORTIVA',
            form: <TabE_Vida_Deportiva 
                data={formData.vidaDeportiva} // <-- Si formData.vidaDeportiva es undefined, saltará el error
                onChange={(newData) => updateSection('vidaDeportiva', newData)}
            />
        },
        {
            id: "tab6",
            label: 'DIAGNÓSTICO',
            form: <TabF_Diagnostico 
                data={formData.diagnostico} // <-- Si formData.diagnostico es undefined, saltará el error
                onChange={(newData) => updateSection('diagnostico', newData)}
            />
        }
        */
        {
            id: "tab1",
            label: 'IDENTIDAD',
            form: <TabI_Identidad 
                data={formData.identidad}
                onChange={(newData) => updateSection('identidad', newData)}
            />
        },
        {
            id: "tab2",
            label: 'LEGAL SOCIAL',
            form: <TabII_Legal_Social 
                data={formData.legalSocial}
                onChange={(newData) => updateSection('legalSocial', newData)}
            />
        },
        {
            id: "tab3",
            label: 'PREDIO',
            form: <TabIII_Predio 
                data={formData.predio}
                onChange={(newData) => updateSection('predio', newData)}
            />
        },
        {
            id: "tab4",
            label: 'INFRAESTRUCTURA',
            form: <TabIV_Infra 
                data={formData.infra} // <-- Si formData.infra es undefined, saltará el error
                onChange={(newData) => updateSection('infra', newData)}
            />
        },
        {
            id: "tab5",
            label: 'VIDA DEPORTIVA',
            form: <TabV_Vida_Deportiva 
                data={formData.vidaDeportiva} // <-- Si formData.vidaDeportiva es undefined, saltará el error
                onChange={(newData) => updateSection('vidaDeportiva', newData)}
            />
        },
        {
            id: "tab6",
            label: 'ASISTENCIA Y NECESIDADES',
            form: <TabVI_Diagnostico 
                data={formData.diagnostico} // <-- Si formData.diagnostico es undefined, saltará el error
                onChange={(newData) => updateSection('diagnostico', newData)}
            />
        }       
        
    ];

    

    // Function to handle PDF preview
    const handleDownloadPDF = () => {
        // Change the app state to show the preview
        cambiarEstadoApp('previewViabilidadTécnica');
    };

    const handleTabChange = (activeItem) => {
        console.log("PUMA Elemento activo:", activeItem);
        // Aquí puedes hacer lo que necesites con el activeItem
    };

    return (
        <>
            <StrictMode>
            <Tabs 
                items={items}
                onTabChange={handleTabChange}
                rightContent={
                    area_responsable === 'ÁREA DE PROYECTOS' && (
                        <button
                            onClick={handleDownloadPDF}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                        >
                            <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                            Previsualizar PDF
                        </button>
                    )
                }
            />              
            </StrictMode>
        </>
    );
}

export default NuevaEditRED;